import styled from "styled-components";

export const Title = styled.h1`
  text-align: center;
  font-size: 3rem;
  position: relative;
  font-weight: 600;

  margin: 0;
`;

export const Description = styled.h2`
  font-weight: 400;
  width: 100%;
  text-align: center;
  margin: 4px;
  font-size: 2rem;
  position: relative;
`;

export const Icon = styled.img`
  height: 319px;
  width: 249px;
  position: absolute;
  bottom: 7%;
  right: 2%;
`;
